<template>
  <ProjectsForm :layout="'add'"></ProjectsForm>
</template>

<script type="text/javascript">
  import ProjectsForm from "../components/ProjectsForm/ProjectsForm";

  export default {
    name: "ProjectsAdd",
    components: {ProjectsForm},
    mounted() {
      this.updateLanguage(this.getCurrentLanguage);
    },
  }
</script>